import { css } from '@emotion/react';
import React from 'react';
import { PaddingStyle } from 'styles/PaddingStyle';
import { themeOld } from 'styles/theme';

export const MessagePanel = ({ children, active }: { active?: boolean; children: any }) => {
	return (
		<div
			css={[
				PaddingStyle({ p: 16 }),
				css`
					z-index: 9100;
					position: fixed;
					top: 0;
					right: 0;
					left: 0;
					text-align: center;
					color: #fff;
					background: ${themeOld.COLOR_BASE_RED};
					opacity: 0;
					transform: translate(0, -100%);
					transition: all 0.3s ease-in-out;
					${!!active &&
					css`
						opacity: 1;
						transform: translate(0, 0);
					`}
				`,
			]}
		>
			{children}
		</div>
	);
};
